export default __webpack_public_path__ + "static/media/SECUTECH-INDIA.705f0ef4.jpg";